export const styles: Styles = {
  loading: {
    width: '100%',
    height: '100%',
  },
};
